import {ACCESS_TOKEN, V1_API_URL_PREFIX} from '../Constants';
import {request} from "./ApiUtils";

export function legalActs() {
    return request({
        url: V1_API_URL_PREFIX + "/planning/acts",
        method: 'GET'
    });
}

export function legalRegs() {
    return request({
        url: V1_API_URL_PREFIX + "/planning/regulations",
        method: 'GET'
    });
}

export function legalCops() {
    return request({
        url: V1_API_URL_PREFIX + "/planning/code-of-practice",
        method: 'GET'
    });
}

export function risks() {
    return request({
        url: V1_API_URL_PREFIX + "/planning/risks",
        method: 'GET'
    });
}

export function risksAssessment() {
    return request({
        url: V1_API_URL_PREFIX + "/planning/risk/assessment",
        method: 'GET'
    });
}

export function riskRevision() {
    return request({
        url: V1_API_URL_PREFIX + "/planning/risks/latestRevision",
        method: 'GET'
    });
}

export function addRiskRevision(record) {
    return request({
        url: V1_API_URL_PREFIX + "/planning/risks/add/revision",
        method: 'POST',
        body: JSON.stringify(record)
    });
}

export function saveOrUpdateAct(record) {
    return request({
        url: V1_API_URL_PREFIX + "/planning/acts/update",
        method: 'POST',
        body: JSON.stringify(record)
    });
}

export function saveOrUpdateRisks(record) {
    return request({
        url: V1_API_URL_PREFIX + "/planning/risks/update",
        method: 'POST',
        body: JSON.stringify(record)
    });
}

export function saveOrUpdateReg(record) {
    return request({
        url: V1_API_URL_PREFIX + "/planning/regulations/update",
        method: 'POST',
        body: JSON.stringify(record)
    });
}

export function saveOrUpdateCop(record) {
    return request({
        url: V1_API_URL_PREFIX + "/planning/code-of-practice/update",
        method: 'POST',
        body: JSON.stringify(record)
    });
}

export function saveOrUpdateRiskAssessment(record) {
    return request({
        url: V1_API_URL_PREFIX + "/planning/risks/assessment/update",
        method: 'POST',
        body: JSON.stringify(record)
    });
}

export function deleteAct(record) {
    const headers = new Headers({
        'Content-Type': 'application/json',
    });

    if (localStorage.getItem(ACCESS_TOKEN)) {
        headers.append('Authorization', 'Bearer ' + localStorage.getItem(ACCESS_TOKEN));
    }

    const defaults = {headers: headers};
    let options = Object.assign({}, defaults, {
        url: V1_API_URL_PREFIX + "/planning/act/delete",
        method: 'DELETE',
        body: JSON.stringify(record)
    });

    return fetch(options.url, options)
        .then(response => {
                if (response.status !== 204) {
                    return Promise.reject();
                }
                return Promise.resolve();
            }
        );
}

export function deleteReg(record) {
    const headers = new Headers({
        'Content-Type': 'application/json',
    });

    if (localStorage.getItem(ACCESS_TOKEN)) {
        headers.append('Authorization', 'Bearer ' + localStorage.getItem(ACCESS_TOKEN));
    }

    const defaults = {headers: headers};
    let options = Object.assign({}, defaults, {
        url: V1_API_URL_PREFIX + "/planning/regulation/delete",
        method: 'DELETE',
        body: JSON.stringify(record)
    });

    return fetch(options.url, options)
        .then(response => {
                if (response.status !== 204) {
                    return Promise.reject();
                }
                return Promise.resolve();
            }
        );
}

export function deleteCop(record) {
    const headers = new Headers({
        'Content-Type': 'application/json',
    });

    if (localStorage.getItem(ACCESS_TOKEN)) {
        headers.append('Authorization', 'Bearer ' + localStorage.getItem(ACCESS_TOKEN));
    }

    const defaults = {headers: headers};
    let options = Object.assign({}, defaults, {
        url: V1_API_URL_PREFIX + "/planning/code-of-practice/delete",
        method: 'DELETE',
        body: JSON.stringify(record)
    });

    return fetch(options.url, options)
        .then(response => {
                if (response.status !== 204) {
                    return Promise.reject();
                }
                return Promise.resolve();
            }
        );
}

export function deleteRisk(record) {
    const headers = new Headers({
        'Content-Type': 'application/json',
    });

    if (localStorage.getItem(ACCESS_TOKEN)) {
        headers.append('Authorization', 'Bearer ' + localStorage.getItem(ACCESS_TOKEN));
    }

    const defaults = {headers: headers};
    let options = Object.assign({}, defaults, {
        url: V1_API_URL_PREFIX + "/planning/risks/delete",
        method: 'DELETE',
        body: JSON.stringify(record)
    });

    return fetch(options.url, options)
        .then(response => {
                if (response.status !== 204) {
                    return Promise.reject();
                }
                return Promise.resolve();
            }
        );
}
